import type { RunStatus, ScheduleRead } from '../client'

export const WEEKDAYS = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']

export function localZone() {
  return Intl.DateTimeFormat().resolvedOptions().timeZone
}

export function zones() {
  const all = Intl.supportedValuesOf('timeZone')
  return all.includes('UTC') ? all : ['UTC', ...all]
}

export function ordinal(day: number) {
  const tens = day % 100
  if (tens >= 11 && tens <= 13) return `${day}th`
  return `${day}${{ 1: 'st', 2: 'nd', 3: 'rd' }[day % 10] ?? 'th'}`
}

export function describeSchedule({ frequency, time_of_day, weekday, day_of_month, timezone }: ScheduleRead) {
  const at = time_of_day.slice(0, 5)
  if (frequency === 'weekly') return `Every ${WEEKDAYS[weekday ?? 0]} at ${at} (${timezone})`
  if (frequency === 'monthly') return `Monthly on the ${ordinal(day_of_month ?? 1)} at ${at} (${timezone})`
  return `Daily at ${at} (${timezone})`
}

export const STATUS_LABEL: Record<RunStatus, string> = {
  running: 'Running',
  awaiting_approval: 'Needs approval',
  paused: 'Stopped at a step',
  completed: 'Completed',
  cancelled: 'Cancelled',
  failed: 'Failed',
  skipped: 'Skipped',
}

export const STATUS_TONE: Record<RunStatus, string> = {
  running: 'bg-purple-50 text-purple-700',
  awaiting_approval: 'bg-amber-50 text-amber-800',
  paused: 'bg-amber-50 text-amber-800',
  completed: 'bg-emerald-50 text-emerald-700',
  cancelled: 'bg-stone-100 text-stone-600',
  failed: 'bg-red-50 text-red-700',
  skipped: 'bg-stone-100 text-stone-600',
}

export function duration(start: string, end: string | null) {
  if (!end) return null
  const seconds = Math.max(0, Math.round((new Date(end).getTime() - new Date(start).getTime()) / 1000))
  if (seconds < 60) return `${seconds}s`
  const minutes = Math.floor(seconds / 60)
  return minutes < 60 ? `${minutes}m ${seconds % 60}s` : `${Math.floor(minutes / 60)}h ${minutes % 60}m`
}
